
import { bl_fm_drive_ext_RowClass } from '../../../dbschema/bl_fm_drive_ext.model';
import { bl_fm_drive_hdr_RowClass, bl_fm_drive_hdr_RowInterface } from '../../../dbschema/bl_fm_drive_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class DriveContainerModel extends BaseContainerModel {
  bl_fm_drive_hdr: bl_fm_drive_hdr_RowInterface = new bl_fm_drive_hdr_RowClass();
  bl_fm_drive_exts: bl_fm_drive_ext_RowClass[] = [];
}
